import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBxSKdO52dzhwmDK4KToa0p0QCeI-O2ZZU',
  authDomain: 'yki-test.firebaseapp.com',
  projectId: 'yki-test',
  storageBucket: 'yki-test.firebasestorage.app',
  messagingSenderId: '812065415057',
  appId: '1:812065415057:web:299cef536fce1f21988430',
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
setPersistence(auth, browserLocalPersistence);
const db = getFirestore(firebaseApp);

export { auth, db };
